module.exports = __webpack_public_path__ + "media/images/flags/32/Haiti-7cab9e2daf5b250f6d06dddd8b902516.png";